import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMap } from "@fortawesome/free-solid-svg-icons";
import { modulo10 } from "../../routes/Module10";
import LayoutActividad from "../../components/LayoutActividad";
import Sidebar from "./Sidebar";
import Imagen from "../../images/modulo10/legislativo.png";
import AudioPlayer from "../../audioPlayer/AudioPlayer";
import Audio from "../../audios/modulo10/Inicio.mp3";

const Modulo1 = () => {
  const nextUnity = modulo10.content[0];
  const nextActivity = nextUnity.activities[0];

  const pages = {
    titleNext: `${nextActivity.name}`,
    linkNext: `${modulo10.url}/${nextUnity.path}/${nextActivity.path}`,
  };
  const crumbs = [
    {
      title: `${modulo10.title} > Inicio `,
      url: "/" + modulo10.url,
    },
  ];
  const metadata = {
    color: modulo10.color,
    title: `${modulo10.title}`,
    name: modulo10.title,
  };
  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <div>
        <h1 className="my-5">{modulo10.title}</h1>
        <AudioPlayer track={Audio} />
      </div>

      <div className="">
        <img src={Imagen} className="img-fluid" alt="..." />
      </div>
      <div className="unit-options my-5">
        <a href={'https://ciudadania.pe/actividades-interactivas/'+pages.linkNext}>
          <button className={`btn btn-${modulo10.color} me-2`}>
            Empezar actividades <FontAwesomeIcon icon={faMap} />
          </button>
        </a>
      </div>
    </LayoutActividad>
  );
};

export default Modulo1;
